import { reRoomyTermsExtended } from './reRoomyExtended';

/** Full terms page content per app slug. Missing slug → /{slug}/terms-of-use shows 404. */
export function getTermsPageContent(appSlug) {
  if (appSlug === 're-roomy') {
    return reRoomyTermsExtended;
  }
  return null;
}
